// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlaidAccountDto
 */
export interface IPlaidAccountDto {
    /**
     * 
     * @type {string}
     * @memberof IPlaidAccountDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IPlaidAccountDto
     */
    mask?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlaidAccountDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlaidAccountDto
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlaidAccountDto
     */
    subtype: string;
    /**
     * 
     * @type {string}
     * @memberof IPlaidAccountDto
     */
    verification_status?: IPlaidAccountDtoVerificationStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPlaidAccountDtoVerificationStatusEnum {
    AUTOMATICALLY_VERIFIED = 'AUTOMATICALLY_VERIFIED',
    PENDING_AUTOMATIC_VERIFICATION = 'PENDING_AUTOMATIC_VERIFICATION',
    PENDING_MANUAL_VERIFICATION = 'PENDING_MANUAL_VERIFICATION',
    MANUALLY_VERIFIED = 'MANUALLY_VERIFIED',
    VERIFICATION_EXPIRED = 'VERIFICATION_EXPIRED',
    VERIFICATION_FAILED = 'VERIFICATION_FAILED',
    DATABASE_MATCHED = 'DATABASE_MATCHED',
    DATABASE_INSIGHTS_PASS = 'DATABASE_INSIGHTS_PASS',
    DATABASE_INSIGHTS_PASS_WITH_CAUTION = 'DATABASE_INSIGHTS_PASS_WITH_CAUTION',
    DATABASE_INSIGHTS_FAIL = 'DATABASE_INSIGHTS_FAIL',
    DATABASE_INSIGHTS_PENDING = 'DATABASE_INSIGHTS_PENDING',
    INSTANTLY_VERIFIED = 'INSTANTLY_VERIFIED'
}


/**
 * Check if a given object implements the IPlaidAccountDto interface.
 */
export function instanceOfIPlaidAccountDto(value: object): value is IPlaidAccountDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('subtype' in value) || value['subtype'] === undefined) return false;
    return true;
}

export function IPlaidAccountDtoFromJSON(json: any): IPlaidAccountDto {
    return IPlaidAccountDtoFromJSONTyped(json, false);
}

export function IPlaidAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlaidAccountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'mask': json['mask'] == null ? undefined : json['mask'],
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : json['type'],
        'subtype': json['subtype'],
        'verification_status': json['verification_status'] == null ? undefined : json['verification_status'],
    };
}

export function IPlaidAccountDtoToJSON(json: any): IPlaidAccountDto {
    return IPlaidAccountDtoToJSONTyped(json, false);
}

export function IPlaidAccountDtoToJSONTyped(value?: IPlaidAccountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'mask': value['mask'],
        'name': value['name'],
        'type': value['type'],
        'subtype': value['subtype'],
        'verification_status': value['verification_status'],
    };
}

